<template>
  <browse-filter name="Sort by">
    <browse-filter-radio
      label="Recommended"
      name="sort"
      value="recommended"
      :checked="value === 'recommended'"
      @click="select"
    />
    <browse-filter-radio
      label="Latest"
      name="sort"
      value="latest"
      :checked="value === 'latest'"
      @click="select"
    />
    <browse-filter-radio
      label="# of customer ratings"
      name="sort"
      value="review_count"
      :checked="value === 'review_count'"
      @click="select"
    />
    <browse-filter-radio
      label="Avg customer rating"
      name="sort"
      value="rating"
      :checked="value === 'rating'"
      @click="select"
    />
    <browse-filter-radio
      label="Price: Low to High"
      name="sort"
      value="price_low"
      :checked="value === 'price_low'"
      @click="select"
    />
    <browse-filter-radio
      label="Price: High to Low"
      name="sort"
      value="price_high"
      :checked="value === 'price_high'"
      @click="select"
    />
    <browse-filter-radio
      label="Ending soon"
      name="sort"
      value="ending"
      :checked="value === 'ending'"
      @click="select"
    />
  </browse-filter>
</template>
<script>
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterRadio from './BrowseFilterRadio.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterRadio,
  },
  props: {
    value: {
      type: String,
      default: 'recommended',
    },
  },
  methods: {
    select(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.browse-filter {
  display: none;
}

@include media-breakpoint-down(sm) {
  .browse-filter {
    display: block;
  }
}
</style>
